<div class="ui padded container">
  <app-article-filter (applied)="applyArticleFilter($event)"
                      [articlesFilter]="articlesFilter"
                      [numberOfArticles]="collectionSize"
                      [topics]="topics" [subjectAreas]="subjectAreas"
                      [isAdmin]="userRoles.includes(clientRoles.IS_ADMIN)"
                      [user]="user"
  ></app-article-filter>
  <div class="ui segment">
    <app-articles-sort (sortParamSelected)="changeSort($event)"></app-articles-sort>
  </div>
  <!--ARTIKEL ITEMS-->
  <div class="top attached ui segment">
    <div class="ui divided items">
      @for (article of articles; track article._id) {
        <div class="item">
          <div class="content">
            <a class="header" [routerLink]="[article._id]">
              <i class="sticky note outline icon"></i>
              {{ article | i18nSelect:'title':'englishTitle' }}
            </a>
            @if (isFavoriteArticle(article)) {
              <i class="yellow favorite icon active" (click)="removeArticleFromFavorites(article)"
                 (keydown)="addArticleToFavorites(article)" tabindex="-1"
                 title="Artikel aus Lesezeichen entfernen!" i18n-title="@@articles-remove-bookmark"></i>
            } @else {
              <i class="black favorite icon active" (click)="addArticleToFavorites(article)"
                 (keydown)="addArticleToFavorites(article)" tabindex="-1"
                 title="Artikel zu Lesezeichen hinzufügen!"
                 i18n-title="@@articles-add-bookmark"></i>
            }
            <div class="meta">
              @if (userRoles.includes(clientRoles.IS_AUTHOR)) {
                <ng-container i18n="@@articles-edited">Erstellt/Bearbeitet am: {{ article?.updatedAt | date }}</ng-container>
              }
              <ul class="ui relaxed bulleted list">
                @for (deadline of article.deadlines; track deadline) {
                  <li class="item" i18n="@@articles-until">{{ deadline | i18nSelect:'title':'englishTitle' }} bis zum {{ deadline.date | date}}</li>
                }
              </ul>
            </div>
            <div [innerHTML]="(article | shortDescription)"></div>
            <div class="extra">
              <a class="ui right floated primary button" [routerLink]="['/articles', article._id]"
                 i18n="@@articles-to-article">
                Zum Artikel
                <i class="right chevron icon"></i>
              </a>
              @if (user | canEdit:article:userRoles) {
                <a class="ui right floated secondary button" [routerLink]="['/author/articles/edit', article._id]"
                   i18n="@@articles-edit">
                  <i class="edit icon"></i>
                  Bearbeiten
                </a>
              }
            </div>
          </div>
        </div>
      } @empty {
        <div class="item" i18n="@@articles-no-articles"> Keine Artikel vorhanden!</div>
      }
    </div>
  </div>
  <!--PAGINATION-->
  <div class="centered">
    <sui-pagination [maxSize]="5" [canRotate]="true" [hasEllipses]="true" [collectionSize]="collectionSize"
                    [pageSize]="articlesFilter.pageSize!" [hasNavigationLinks]="true" [hasBoundaryLinks]="true"
                    [(page)]="articlesFilter.selectedPage!" (pageChange)="handlePageChange()">
    </sui-pagination>
  </div>
</div>
